export enum EDmsFlag {
  DmsReady = "dmsReady"
}